<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-left mr-auto">
    <li class="nav-item d-none d-md-block d-lg-none">
        <a (click)="toggleSidebar.emit()" class="nav-link sidebartoggler waves-effect waves-light" href="javascript:void(0)">
            <i class="mdi mdi-menu font-24"></i>
        </a>
    </li>
	<!-- <li class="d-none d-md-block">
		<form class="app-search">
            <input type="text" class="form-control" placeholder="Search..."> 
			<a class="srh-btn"><i class="ti-search"></i></a> 
		</form>
    </li> -->
</ul>

<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<!-- <ul class="navbar-nav float-right">
    <li class="nav-item d-md-block">
        <a (click)="toggleSidebar.emit()" class="nav-link text-white" href="javascript:void(0)">
            Cerrar sesión <i class="fas fa-sign-out-alt"></i>
        </a>
    </li>
</ul> -->